// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smart-components-wrapper{overflow-x:hidden;overflow:hidden;min-height:100vh;padding-top:140px}@media (max-width:767px){.smart-components-wrapper{padding-top:88px}}", ""]);
// Exports
module.exports = exports;
